module.exports = __webpack_public_path__ + "static/media/item_41_5.0e3aae44.png";